import React from 'react';
import { mockReconciliation, formatCurrency } from '../../../services/mockData';

const ReconciliationReport = () => (
  <div className="fade-in">
    <div className="page-header">
      <div className="breadcrumb">Bank &amp; Cash Reports <span>/ Reconciliation Report</span></div>
      <h2>Reconciliation Report</h2>
    </div>

    <div className="filter-bar">
      <div className="form-group">
        <label>Select Ledger</label>
        <select className="form-control">
          <option>BANK OF INDIA-000252363252111</option>
        </select>
      </div>
      <div className="form-group">
        <label>From</label>
        <input type="text" className="form-control" defaultValue="01-04-2025" />
      </div>
      <div className="form-group">
        <label>To</label>
        <input type="text" className="form-control" defaultValue="01-02-2026" />
      </div>
      <div className="form-group" style={{ justifyContent: 'flex-end' }}>
        <div className="btn-group">
          <button className="btn btn-primary">🔍 Search</button>
          <button className="btn btn-warning btn-sm">🖨️ Print / Save as PDF</button>
          <button className="btn btn-success btn-sm">📊 Export To Excel</button>
        </div>
      </div>
    </div>

    <div className="card">
      <div className="report-header">
        <h3>Vitthal Plaza Co-Op Housing Society LTD</h3>
        <p>Registration Number: TNADO(M/HSG/TC)/25796/YEAR-2023 | dr Sagar(Dombivali)</p>
        <p style={{ fontWeight: '700', marginTop: '6px' }}>
          Bank: BANK OF INDIA A/cNo: 002052363252111 Bank Reconciliation Statement as on Dated: 01-02-2026 / 2025-2026
        </p>
      </div>

      <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' }}>
        <div className="stat-card" style={{ flex: 1, minWidth: '200px' }}>
          <div className="stat-icon blue">🏦</div>
          <div className="stat-info">
            <div className="stat-value" style={{ fontSize: '16px' }}>₹5,93,24,008.88</div>
            <div className="stat-label">Closing Balance as per System</div>
          </div>
        </div>
        <div className="stat-card" style={{ flex: 1, minWidth: '200px', borderLeftColor: '#ff9f1c' }}>
          <div className="stat-icon orange">⚠️</div>
          <div className="stat-info">
            <div className="stat-value" style={{ fontSize: '16px' }}>₹6,45,315.00</div>
            <div className="stat-label">Cheques Deposited but not Cleared</div>
          </div>
        </div>
      </div>

      <div className="section-title" style={{ marginBottom: '12px' }}>LESS: Cheques Deposited but not Cleared</div>
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Posted Date</th>
              <th>Particulars</th>
              <th>Type</th>
              <th>V.No</th>
              <th>ChqNo</th>
              <th>Chq Dated</th>
              <th className="amount">Dr Amount</th>
              <th className="amount">Cr Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {mockReconciliation.map((r, i) => (
              <tr key={i}>
                <td>12-04-2024</td>
                <td>F0502-Ghawshankar Lal</td>
                <td>{r.type}</td>
                <td>{r.voucherNo}</td>
                <td>{r.chqNo}</td>
                <td>{r.chqDate}</td>
                <td className="amount dr">{r.drAmount > 0 ? formatCurrency(r.drAmount) : ''}</td>
                <td className="amount cr">{formatCurrency(r.crAmount)}</td>
                <td><span className="badge badge-warning">{r.status}</span></td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={6} style={{ textAlign: 'right' }}>Total Uncleared</td>
              <td className="amount">0.00</td>
              <td className="amount">{formatCurrency(mockReconciliation.reduce((s, r) => s + r.crAmount, 0))}</td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
);

export default ReconciliationReport;
